
















import { Component, Vue } from 'vue-property-decorator';
import HeaderLogoDm from '@/components/HeaderLogoDm.vue';
import HeaderLogoAnytime from '@/components/HeaderLogoAnytime.vue';

@Component({
  components: {
    HeaderLogoDm,
    HeaderLogoAnytime
  }
})
export default class Layout extends Vue {

  public logout() {
    localStorage.removeItem('token');
    this.$router.push('/login');
  }
}
